/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ConnectorErrorResponse } from '../model/connectorErrorResponse';
import { CreateSourceLinkRequest } from '../model/createSourceLinkRequest';
import { SourceDriveView } from '../model/sourceDriveView';
import { SourceItemView } from '../model/sourceItemView';
import { SourceLinkView } from '../model/sourceLinkView';
import { SourceSiteView } from '../model/sourceSiteView';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class SourceLinkControllerService {

    protected basePath = 'https://api.beta.planbic.de';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Ordner verknüpfen; der erste Abgleich startet automatisch
     * 
     * @param body 
     * @param projectId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createSourceLink(body: CreateSourceLinkRequest, projectId: number, observe?: 'body', reportProgress?: boolean): Observable<SourceLinkView>;
    public createSourceLink(body: CreateSourceLinkRequest, projectId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SourceLinkView>>;
    public createSourceLink(body: CreateSourceLinkRequest, projectId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SourceLinkView>>;
    public createSourceLink(body: CreateSourceLinkRequest, projectId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createSourceLink.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling createSourceLink.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SourceLinkView>('post',`${this.basePath}/projects/${encodeURIComponent(String(projectId))}/source-links`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Verknüpfung lösen; Dateien behalten oder in den Papierkorb
     * 
     * @param projectId 
     * @param linkId 
     * @param mode 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteSourceLink(projectId: number, linkId: string, mode?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteSourceLink(projectId: number, linkId: string, mode?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteSourceLink(projectId: number, linkId: string, mode?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteSourceLink(projectId: number, linkId: string, mode?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling deleteSourceLink.');
        }

        if (linkId === null || linkId === undefined) {
            throw new Error('Required parameter linkId was null or undefined when calling deleteSourceLink.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (mode !== undefined && mode !== null) {
            queryParameters = queryParameters.set('mode', <any>mode);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/projects/${encodeURIComponent(String(projectId))}/source-links/${encodeURIComponent(String(linkId))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Ein verknüpfter Ordner
     * 
     * @param projectId 
     * @param linkId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSourceLink(projectId: number, linkId: string, observe?: 'body', reportProgress?: boolean): Observable<SourceLinkView>;
    public getSourceLink(projectId: number, linkId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SourceLinkView>>;
    public getSourceLink(projectId: number, linkId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SourceLinkView>>;
    public getSourceLink(projectId: number, linkId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling getSourceLink.');
        }

        if (linkId === null || linkId === undefined) {
            throw new Error('Required parameter linkId was null or undefined when calling getSourceLink.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SourceLinkView>('get',`${this.basePath}/projects/${encodeURIComponent(String(projectId))}/source-links/${encodeURIComponent(String(linkId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Ordner und Dateien eines Ordners; ohne folderId die Wurzel
     * 
     * @param projectId 
     * @param connectionSiteId 
     * @param driveId 
     * @param folderId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listSourceChildren(projectId: number, connectionSiteId: string, driveId: string, folderId?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<SourceItemView>>;
    public listSourceChildren(projectId: number, connectionSiteId: string, driveId: string, folderId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SourceItemView>>>;
    public listSourceChildren(projectId: number, connectionSiteId: string, driveId: string, folderId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SourceItemView>>>;
    public listSourceChildren(projectId: number, connectionSiteId: string, driveId: string, folderId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling listSourceChildren.');
        }

        if (connectionSiteId === null || connectionSiteId === undefined) {
            throw new Error('Required parameter connectionSiteId was null or undefined when calling listSourceChildren.');
        }

        if (driveId === null || driveId === undefined) {
            throw new Error('Required parameter driveId was null or undefined when calling listSourceChildren.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (folderId !== undefined && folderId !== null) {
            queryParameters = queryParameters.set('folderId', <any>folderId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<SourceItemView>>('get',`${this.basePath}/projects/${encodeURIComponent(String(projectId))}/source-links/sites/${encodeURIComponent(String(connectionSiteId))}/drives/${encodeURIComponent(String(driveId))}/children`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Dokumentbibliotheken einer zugeordneten Site
     * 
     * @param projectId 
     * @param connectionSiteId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listSourceDrives(projectId: number, connectionSiteId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<SourceDriveView>>;
    public listSourceDrives(projectId: number, connectionSiteId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SourceDriveView>>>;
    public listSourceDrives(projectId: number, connectionSiteId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SourceDriveView>>>;
    public listSourceDrives(projectId: number, connectionSiteId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling listSourceDrives.');
        }

        if (connectionSiteId === null || connectionSiteId === undefined) {
            throw new Error('Required parameter connectionSiteId was null or undefined when calling listSourceDrives.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<SourceDriveView>>('get',`${this.basePath}/projects/${encodeURIComponent(String(projectId))}/source-links/sites/${encodeURIComponent(String(connectionSiteId))}/drives`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Verknüpfte Ordner des Projekts mit Sync-Stand
     * 
     * @param projectId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listSourceLinks(projectId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<SourceLinkView>>;
    public listSourceLinks(projectId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SourceLinkView>>>;
    public listSourceLinks(projectId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SourceLinkView>>>;
    public listSourceLinks(projectId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling listSourceLinks.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<SourceLinkView>>('get',`${this.basePath}/projects/${encodeURIComponent(String(projectId))}/source-links`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Sites, die dem Projekt zugeordnet sind (Verknüpfen-Assistent)
     * 
     * @param projectId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listSourceSites(projectId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<SourceSiteView>>;
    public listSourceSites(projectId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SourceSiteView>>>;
    public listSourceSites(projectId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SourceSiteView>>>;
    public listSourceSites(projectId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling listSourceSites.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<SourceSiteView>>('get',`${this.basePath}/projects/${encodeURIComponent(String(projectId))}/source-links/sites`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Jetzt synchronisieren
     * 
     * @param projectId 
     * @param linkId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public syncSourceLink(projectId: number, linkId: string, observe?: 'body', reportProgress?: boolean): Observable<SourceLinkView>;
    public syncSourceLink(projectId: number, linkId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SourceLinkView>>;
    public syncSourceLink(projectId: number, linkId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SourceLinkView>>;
    public syncSourceLink(projectId: number, linkId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling syncSourceLink.');
        }

        if (linkId === null || linkId === undefined) {
            throw new Error('Required parameter linkId was null or undefined when calling syncSourceLink.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SourceLinkView>('post',`${this.basePath}/projects/${encodeURIComponent(String(projectId))}/source-links/${encodeURIComponent(String(linkId))}/sync`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
